<template>
	<div class="popover-container" ref="popoverContainer">
		<button @click.stop.prevent="togglePopover" class="popover-trigger">
			<slot name="trigger" />
		</button>

		<div v-if="isOpen" class="popover-content" ref="popoverContent" @click="togglePopover">
			<slot name="content"></slot>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const emit = defineEmits<{
	(e: 'toggled', isOpen: boolean): void;
}>();

const isOpen = ref(false);
const popoverContainer = ref<HTMLElement | null>(null);
const popoverContent = ref<HTMLElement | null>(null);

function togglePopover() {
	isOpen.value = !isOpen.value;
	emit('toggled', isOpen.value);
}

function handleClickOutside(event: MouseEvent) {
	if (
		popoverContainer.value &&
		!popoverContainer.value.contains(event.target as Node) &&
		popoverContent.value &&
		!popoverContent.value.contains(event.target as Node)
	) {
		isOpen.value = false;
	}
}

onMounted(() => {
	document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
	document.removeEventListener('click', handleClickOutside);
});
</script>

<style lang="scss" scoped>
.popover-container {
	position: relative;
	display: inline-block;
}

.popover-trigger {
	all: unset;
	cursor: pointer;
}

.popover-content {
	position: absolute;
	bottom: 100%;
	right: 0;
	margin-bottom: 8px;
	z-index: 50;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
}
</style>
